import type { ICategory } from "~/typings/categories";

export default (catalogType: "goods" | "promo") => {
  const route = useRoute();
  const categoriesStore = useCategoriesStore();

  const categoryId = computed(() => (route.params.category || "") as string);
  const categorySlug = computed(() => route.params.slug ?? "");
  const currentCategory = computed<ICategory | null>(() =>
    categoriesStore.getCategoryById(categoryId.value, catalogType),
  );
  const isSlugError = computed(() => {
    if (
      ["promo-catalog-category-categorySlug", RouteNames.PromoCatalog as string, RouteNames.Catalog as string].includes(String(route.name))
    )
      return false;
    return currentCategory.value && categorySlug.value !== currentCategory.value.code;
  });
  if (isSlugError.value) {
    navigateTo(currentCategory.value?.url, { redirectCode: 301, replace: true });
  }
  const isPageError = computed(() => route.query.page && isNaN(Number(route.query.page)));
  const isCategoryError = computed(() =>
    catalogType === "promo" ? categoryId.value && !currentCategory.value : false,
  );
  const isError = computed(() => {
    if (isCategoryError.value) return "category";
    if (isPageError.value) return "page";
    return null;
  });

  return {
    isError,
  };
};
